// Simple printing/PDF approach using browser print-to-PDF for proper Arabic shaping & RTL.
// jsPDF has poor native Arabic shaping; printing the rendered HTML is the most reliable.
import { SCHOOL_LOGO, SCHOOL_NAME } from "./constants";

export function printHtmlReport({ title, columns, rows, meta = [] }) {
  const w = window.open("", "_blank", "width=1100,height=800");
  if (!w) return;
  const today = new Date().toLocaleDateString("ar-SA-u-nu-latn");
  const metaHtml = meta.map(m => `<div class="meta"><span>${m.label}:</span> <strong>${m.value}</strong></div>`).join("");
  const head = columns.map(c => `<th>${c.header}</th>`).join("");
  const body = rows.map((r, idx) => {
    const cells = columns.map(c => `<td>${r[c.key] ?? ""}</td>`).join("");
    return `<tr><td class="num">${idx + 1}</td>${cells}</tr>`;
  }).join("");

  w.document.write(`<!doctype html>
  <html lang="ar" dir="rtl">
    <head>
      <meta charset="utf-8" />
      <title>${title}</title>
      <link href="https://fonts.googleapis.com/css2?family=Cairo:wght@500;700;800&family=Tajawal:wght@400;500;700&display=swap" rel="stylesheet">
      <style>
        * { box-sizing: border-box; }
        body { font-family: 'Tajawal','Cairo',sans-serif; padding: 28px 32px; color:#0F172A; }
        h1 { font-family:'Cairo',sans-serif; font-size: 22px; margin: 4px 0 0; color:#0F766E; }
        .school { display:flex; gap:14px; align-items:center; border-bottom: 2px solid #0F766E; padding-bottom: 14px; }
        .school img { width: 72px; height: 72px; object-fit: contain; }
        .school .name { font-family:'Cairo',sans-serif; font-size: 20px; font-weight: 800; color:#115E59; }
        .school .sub { color:#475569; font-size: 13px; margin-top: 2px; }
        .title-row { display:flex; justify-content: space-between; align-items: center; margin-top: 18px; }
        .meta-row { display:flex; gap: 18px; flex-wrap:wrap; margin: 10px 0 18px; font-size: 13px; color:#334155; }
        .meta span { color:#64748B; }
        table { width: 100%; border-collapse: collapse; font-size: 13px; }
        thead th { background:#0F766E; color:white; padding:10px 8px; text-align:right; font-family:'Cairo',sans-serif; font-weight:700; }
        tbody td { padding: 9px 8px; border-bottom: 1px solid #E2E8F0; text-align:right; }
        tbody tr:nth-child(even) td { background:#F8FAFC; }
        .num { width: 42px; color:#64748B; text-align:center; }
        .footer { margin-top: 22px; display:flex; justify-content: space-between; color:#64748B; font-size: 12px; border-top:1px dashed #CBD5E1; padding-top:10px; }
        .stamp { color:#0F766E; font-weight:700; }
        @media print {
          body { padding: 14mm; }
          .no-print { display:none; }
        }
      </style>
    </head>
    <body>
      <div class="school">
        <img src="${SCHOOL_LOGO}" alt="logo" />
        <div>
          <div class="name">${SCHOOL_NAME}</div>
          <div class="sub">المملكة العربية السعودية — نظام إدارة الطلاب</div>
        </div>
      </div>
      <div class="title-row">
        <h1>${title}</h1>
        <div class="stamp">تاريخ الطباعة: ${today}</div>
      </div>
      <div class="meta-row">${metaHtml}<div class="meta"><span>إجمالي السجلات:</span> <strong>${rows.length}</strong></div></div>
      <table>
        <thead><tr><th class="num">#</th>${head}</tr></thead>
        <tbody>${body || `<tr><td colspan="${columns.length + 1}" style="text-align:center;color:#64748B;padding:20px">لا توجد بيانات</td></tr>`}</tbody>
      </table>
      <div class="footer">
        <div>تم إنشاء التقرير بواسطة نظام إدارة الطلاب</div>
        <div>© ${new Date().getFullYear()} — مدارس العلم النافع الأهلية</div>
      </div>
      <div style="margin-top:6px;display:flex;flex-direction:column;align-items:center;gap:4px;color:#0F766E;font-size:12px;font-family:'Cairo',sans-serif;border-top:1px solid #E2E8F0;padding-top:8px">
        <div>إدارة المدرسة: <strong>الأستاذ محمد عبدالله الصبحي</strong></div>
        <div style="display:flex;gap:14px;align-items:center">
          <span>برمجة وتصميم: <strong>الأستاذ محمد كامل</strong></span>
          <span style="color:#94A3B8">•</span>
          <span dir="ltr" style="font-variant-numeric:tabular-nums">0590939015</span>
        </div>
      </div>
      <script>window.onload = () => { setTimeout(() => window.print(), 350); };</script>
    </body>
  </html>`);
  w.document.close();
}
